import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DialogClientsSocis } from '../../dialog/clientssocis/dialog.component.clientssocis';
import { DialogContactes } from '../../dialog/contactes/dialog.component.contactes';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';

import { ClientSociUpdate, ClientSociElement } from '../interfaces';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';
import { ContactesService } from '../../services/contactes/contactes.service';

import { IClientsSocis, IClientsSocisResponse } from '../../clientsSocis/clientssocis.interfaces';
import { IContactes, IContactesResponse } from '../../contactes/contactes.interfaces';

@Component({
  selector: 'mcrit-gestio-manage-project-clients-socis-list',
  templateUrl: './clients-socis-list.component.html',
  styleUrls: ['clients-socis-list.component.css'],
  providers:[ClientsSocisService, ContactesService, ProjectsService]
})

export class ClientsSocisListComponent implements OnInit {
  @Input() showAsyncProgress: boolean = false;
  @Input('clientsSocisList') clientsSocisList: any;
  @Input('idProjecte') idProjecte: any; //o bé proposal
  @Input() tipus: string;
  @Input() routekey: string;
  @Output() changeClientSoci: EventEmitter<ClientSociUpdate> = new EventEmitter();
  @Output() deleteClientSoci: EventEmitter<ClientSociUpdate> = new EventEmitter();

  public availableClientsSocis: Array<ClientSociElement> = [];
  public availableContacts: Array<any> = [];
  public showEditor: boolean = false;
  public error: any;
  public txFiltre: string = '';

  public newClientSociId: string = '';
  public newContactId: string = '';
  public newClientFinal: boolean = false;
  public newCPercPart: string = '';
  public newCLider: string = null;

  private clientSociModel: IClientsSocis = {
      'id': 'NEW',
      'nom': null,
      'tipus': null,
      'telefon': null,
      'adreca': null,
      'client': true,
      'soci': true,
      'localitzacio': null,
      'descripcio': null,
      'comentari': null,
      'web': null,
      'mail': null,
      'country': null,
      'cif': null
  };

  private contactesModel: IContactes = {
    'id': 'NEW',
    'nom': null,
    'tipus': null,
    'email': null,
    'tlf': null,
//    'skype': null,
    'linkedin': null,
    'mobil': null,
    'comentari': null,
    'empresa': null,
    'ambit': null,
    'adreca': null,
    'id_client': null,
    'professional': null,
    'nota': null,
    'data_nota': null,
    'pais': null,
    'tematica1': null,
    'tematica2': null,
    'tematica3': null,
    'tematica4': null,
    'tematica5': null
  };

  public editClientSociData: IClientsSocis;
  public editContacteData: IContactes;

  public getContactesClientSoci(){
    this.clientsSocisService.getContactesClientSoci(this.newClientSociId)
    .subscribe(
      contactes => this.availableContacts = contactes, error => {
        if (error.status === 404) {
          this.error = {
            status: 404,
            msg: 'No existeix cap contacte associat al identificador de client/soci',
            statusText: error.statusText
          };
        }
      }
    );
  }

  public trackItem (index: number, item: any) {
   return item;
  }

  public creaClientSoci($event): void {
    this.editClientSociData = Object.assign(
      {},
      this.clientSociModel,
      { id : 'NEW' }
    );
    let dialogFactRef=this.dialog.open(DialogClientsSocis, {disableClose: true, height: '620px', data: this.editClientSociData })
    
    $event.preventDefault();$event.stopPropagation();
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editClientSociData = results;
      this.addOrUpdateClientSoci();
    });
  }

  public addOrUpdateClientSoci(): void {
    this.showAsyncProgress = true;
    if (this.editClientSociData.id === 'NEW') {
      this.clientsSocisService.createClientSoci(this.editClientSociData)
        .subscribe(newClientSoci => {console.log("S'ha creat l'element");
          this.filterClientsSocis();
          this.showAsyncProgress = false;
      });
    };
  }

  public creaContacte($event): void {
    this.editContacteData = Object.assign( {}, this.contactesModel, { id : 'NEW', id_client: this.newClientSociId } );
    let dialogFactRef=this.dialog.open(DialogContactes, {disableClose: true, height: '590px', data: this.editContacteData })
   
    $event.preventDefault();$event.stopPropagation();
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editContacteData = results;
      this.addOrUpdateContacte();
    });
  }

  public addOrUpdateContacte(): void {
    this.showAsyncProgress = true;

    if (this.editContacteData.id === 'NEW') {
      this.contactesService.create(this.editContacteData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");
          this.availableContacts.push({id: this.editContacteData.id});
          this.showAsyncProgress = false;
      });
    }
  }

  public setClientFinal(id,idClient){
    this.clientsSocisList.filter(item => item.id !== idClient).map(item => item.client_final = false);
    this.clientsSocisService.setClientFinal(this.idProjecte, idClient, 'proposal').subscribe(resultats => {});
  }

  public addClientSoci(): void {
    let clientSociToAdd = null;
    let contacteToAdd = null;

    if (!this.newClientSociId || this.newClientSociId === '')return;
    //if (!this.newContactId || this.newContactId === '')return; //S'admeten clients sense contacte

    clientSociToAdd = this.availableClientsSocis
      .find((item: ClientSociElement): boolean => { return item.id == this.newClientSociId; });
    if(this.newContactId)
      contacteToAdd = this.availableContacts
      .find((item: ClientSociElement): boolean => { return item.id == this.newContactId; });

    this.updateClientSoci(clientSociToAdd, contacteToAdd, this.newClientFinal, this.newCPercPart, this.newCLider);
    this.showEditor = false;
  }

  public openEditor(): void {
    this.showEditor = true;
    this.newClientSociId = '';
    this.filterClientsSocis();
  }

  public closeEditor() {
    this.showEditor = false;
  }

  public updateClientSoci(clientSoci, contacte, final, percPart, Eslider): void {
    this.changeClientSoci.emit({idClientSoci: clientSoci.id, idContacte: (contacte?contacte.id:null), final: final, perc_participacio: percPart, lider: Eslider});
  }

  public eliminarClientSoci(clientSociToDel, contacteToDel, percPart): void {
    this.deleteClientSoci.emit({idClientSoci: clientSociToDel, idContacte: contacteToDel, final: null, perc_participacio: percPart, lider: null});
  }

  public anarClientSoci(contacteToGo): void {
     this.router.navigate(['fitxaContactes',contacteToGo]);
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProjectsService, private contactesService: ContactesService,  private clientsSocisService: ClientsSocisService, public dialog:MatDialog, protected router: Router ){}

  private filterClientsSocis() {
    if (!this.clientsSocisList)return;
    const currentClientSoci = new Set(this.clientsSocisList.map(item => item.id));
    this.clientsSocisService.get(this.tipus, this.idProjecte)
      .subscribe(
        list => {
          this.availableClientsSocis = list;
          this.availableClientsSocis = this.availableClientsSocis.filter((v,i) => this.availableClientsSocis.findIndex(item => item["nom"] == v["nom"]) === i);
        },
        err => console.log(err)
      );
  }

  ngOnInit(){this.filterClientsSocis();}
}
